<script setup>
import { usePlatform } from '/app/composables/platform';
import { usePlatformStaff } from '/app/composables/staff';
import { provide, computed } from 'vue';

const { currentPlatform } = usePlatform();

const platformSlug = computed(() => currentPlatform.value?.slug);
const { data } = usePlatformStaff(platformSlug);

provide('platformStaff', data);
</script>

<template>
    <slot />
</template>